import React, { useState } from "react";
import { motion } from "framer-motion";
import { WHATSAPP_HREF } from "@/lib/constants";
import { track } from "@/lib/track";
import waIcon from "@/assets/whatsapp-icon.png";

/**
 * Floating WhatsApp chat-bubble — bottom-right, all viewports.
 * Uses the official WhatsApp icon image (green bubble with white phone),
 * sitting above a subtle pulse ring. The image carries its own green fill
 * + white halo, so the wrapper has no background of its own.
 */
const FloatingWhatsApp = () => {
    const [hovered, setHovered] = useState(false);

    return (
        <div
            className="fixed right-4 sm:right-6 bottom-24 md:bottom-6 z-50 pointer-events-none"
            data-testid="floating-whatsapp"
        >
            <div
                className="relative w-[60px] h-[60px] sm:w-16 sm:h-16 pointer-events-auto"
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
            >
                {/* Pulse ring — behind the icon, never deforms the image */}
                <span
                    aria-hidden="true"
                    className="absolute inset-1.5 rounded-full bg-whatsapp opacity-45 animate-ping-slow pointer-events-none"
                />

                {/* Desktop tooltip */}
                <motion.div
                    initial={false}
                    animate={{
                        opacity: hovered ? 1 : 0,
                        x: hovered ? 0 : 8,
                    }}
                    transition={{ duration: 0.18 }}
                    aria-hidden={!hovered}
                    className="hidden md:flex absolute right-full mr-3 top-1/2 -translate-y-1/2 items-center bg-brand-dark text-white text-sm font-semibold px-3.5 py-2 rounded-lg whitespace-nowrap shadow-lg pointer-events-none"
                >
                    Discutez avec nous sur WhatsApp
                    <span className="absolute top-1/2 -translate-y-1/2 -right-1 w-2 h-2 rotate-45 bg-brand-dark" />
                </motion.div>

                {/* The official icon — image is its own button */}
                <motion.a
                    href={WHATSAPP_HREF}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="floating-whatsapp-bubble"
                    aria-label="Discutez avec nous sur WhatsApp"
                    onClick={() =>
                        track("whatsapp_click", { location: "floating_bubble" })
                    }
                    initial={{ scale: 0, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    transition={{
                        delay: 0.9,
                        type: "spring",
                        stiffness: 280,
                        damping: 14,
                    }}
                    whileHover={{ scale: 1.08 }}
                    whileTap={{ scale: 0.94 }}
                    className="relative block w-full h-full rounded-full focus:outline-none focus-visible:ring-4 focus-visible:ring-whatsapp/40"
                    style={{
                        filter:
                            "drop-shadow(0 6px 16px rgba(37,211,102,0.4)) drop-shadow(0 2px 6px rgba(0,0,0,0.18))",
                    }}
                >
                    <img
                        src={waIcon}
                        alt="WhatsApp Capital Automobile"
                        width={60}
                        height={60}
                        className="w-full h-full select-none pointer-events-none"
                        draggable={false}
                    />
                </motion.a>
            </div>
        </div>
    );
};

export default FloatingWhatsApp;
